import React from 'react';
import { Box, Typography, TextField, Stack, InputAdornment } from '@mui/material';
import Logo from '../../../../assets/images/orgaLogoFull.png';
import { CustomButton } from '../../../../custom/components';
import loginStyles from './../login.module.css';
import styles from '../../../../custom/style.module.css';
import { Apartment, PersonRounded } from '@mui/icons-material';
import theme from 'custom/theme';
import { appName } from 'custom/constants';
import { loaderRef } from 'components/header/loader';

const ResetPassword = (props) => {
  return (
    <Box className={loginStyles.loginWrapper}>
      <div ref={loaderRef}></div>
      <img src={Logo} alt='logo' className={`${loginStyles.loginLogo} ${styles.mb3}`} />
      <Stack spacing={3} alignItems='center' className={`${styles.w100} ${styles.mb4}`}>
        <Typography fontSize={'1.8rem'} component='span' lineHeight='normal' fontWeight={500}
          className={`${loginStyles.appName} ${loginStyles.loginHeader} ${styles.mb3}`} color='primary'>
          Welcome to {appName}
        </Typography>
        <Typography variant='body1' component='span' lineHeight='normal' fontWeight={'bold'} letterSpacing={'0.4px'}
          className={`${loginStyles.loginHeader} ${styles.mb3}`} color={theme.palette.grey[700]}>
          Reset Password
        </Typography>
      </Stack>

      <form className={styles.w100}>
        <Stack spacing={5} alignItems='center'>
          <TextField
            hiddenLabel
            id='Company'
            variant='standard'
            className={styles.w100}
            placeholder='Company'
            type='text'
            size='small'
            InputLabelProps={{ shrink: false }}
            classes={{ root: loginStyles.textfield }}
            onChange={props.onChange}
            name='company'
            value={props.fields.company}
            disabled={props.company}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start' className={ loginStyles.materialIconContainer }>
                  <Apartment color='primary' className={ loginStyles.materialIcon } />
                </InputAdornment>
              ),
            }}
            error={props.errors.company}
            helperText={props.errors.company}
            FormHelperTextProps={{ className: styles.customFormHelperText }}
          />
          <TextField
            hiddenLabel
            id='Username'
            variant='standard'
            className={styles.w100}
            placeholder='Username / Email'
            type='text'
            size='small'
            InputLabelProps={{ shrink: false }}
            classes={{ root: loginStyles.textfield }}
            onChange={props.onChange}
            name='username'
            value={props.fields.username}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start' className={ loginStyles.materialIconContainer }>
                  <PersonRounded color='primary' className={ loginStyles.materialIcon } />
                </InputAdornment>
              ),
            }}
            error={Boolean(props.errors.username)}
            helperText={props.errors.username}
            FormHelperTextProps={{ className: styles.customFormHelperText }}
          />
          <CustomButton variant='contained' className={`${styles.w100} ${loginStyles.submitBtn}`} onClick={props.onSubmit} disabled={props.submit} >Submit</CustomButton>
          <Typography variant='caption' component='span' lineHeight='normal' className={styles.link} onClick={()=>{
            window.location.href = '/login';
          }}>Back to Login</Typography>          
        </Stack>
      </form>
    </Box>
  );
};

export default ResetPassword;